import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

// BonBoZ: ghim theme sang. Pancake khong co che do toi, giu no la phai bia ban
// toi cho 19 loai bubble ma khong co gi tham chieu. Ha tang `.dark` van nguyen
// ven - bo dong GHIM_SANG ben duoi la tra lai hanh vi cu.
const GHIM_SANG = true;

export const setColorTheme = isOSOnDarkMode => {
  const selectedColorScheme = GHIM_SANG
    ? 'light'
    : LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_SCHEME) || 'auto';
  if (
    (selectedColorScheme === 'auto' && isOSOnDarkMode) ||
    selectedColorScheme === 'dark'
  ) {
    document.body.classList.add('dark');
    document.documentElement.style.setProperty('color-scheme', 'dark');
  } else {
    document.body.classList.remove('dark');
    document.documentElement.style.setProperty('color-scheme', 'light');
  }
};
